export default "__VITE_ASSET__DuWdEX5T__"